"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AdLoopType;
(function (AdLoopType) {
    AdLoopType["xPerPeriod"] = "xPerPeriod";
    AdLoopType["everyXSecs"] = "everyXSecs";
})(AdLoopType = exports.AdLoopType || (exports.AdLoopType = {}));
//# sourceMappingURL=AdLoopType.js.map